import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {

  constructor() { }

  static getControlEmailValidator(email: AbstractControl, confirmEmail: AbstractControl) {

    const validator: ValidatorFn = (control: FormControl): ValidationErrors | null => {

      if (email.value && confirmEmail.value) {
        const isMatch = email.value === confirmEmail.value;
        return isMatch ? null :  { emailNotMatching: true };
      } else {
        return null;
      }
    };
    return validator;

  }


}
